import enviro from 'enviro';
import { getFullUrl } from 'hubspot-url-utils';
const hubspotBasePath = '/connect';
export const getBaseUrl = () => window.location.origin.includes('hubspot') ? hubspotBasePath : '/';
export const getEnv = () => {
  if (window.location.origin.includes('local')) {
    return 'local';
  } else if (enviro.isQa()) {
    return 'qa';
  } else {
    return 'prod';
  }
};
const env = getEnv();
export const paths = {
  DIRECTORY: '/',
  INTRODUCTION: '/introduction',
  CLAIM: '/claim',
  USER: '/member/:username',
  EDIT_USER: '/edit'
};

const getConnectDomain = () => {
  if (env === 'local') return getFullUrl('local');
  if (env === 'qa') return `https://connectqa.co/`;
  return `https://connect.com/`;
};

const getHubspotDomain = () => {
  if (env === 'local') {
    return getFullUrl('local');
  }

  return getFullUrl('app');
};

const toConnect = (path = '') => {
  return `${getConnectDomain()}${env === 'local' ? `${hubspotBasePath}/` : ''}${path}`;
};

const toHubspot = (path = '') => {
  return `${getHubspotDomain()}${hubspotBasePath}/${path}`;
};

export const wormholePaths = {
  wormhole() {
    return toHubspot('wormhole');
  },

  wormholeOrigin() {
    return getHubspotDomain();
  },

  connectOrigin() {
    return getConnectDomain();
  }

};
export const hubspotEditPagePaths = {
  directory() {
    return toConnect();
  },

  edit() {
    return toHubspot('edit');
  },

  claim() {
    return toHubspot('claim');
  },

  user(userName) {
    return toConnect(`member/${userName}`);
  }

};
export const generatePath = {
  directory() {
    return '';
  },

  introduction() {
    return '/introduction';
  },

  user(userName) {
    return `member/${userName}`;
  },

  editUser() {
    return 'edit';
  }

};
export const hardNavigate = url => {
  window.location.href = url;
};